import type { TableOfContentsPageNumberUpdatePanelFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { AttributePanel } from "../AttributePanel";
import { useDeleteTableOfContentsPageNumberFromPanelMutation } from "../../client/generated";

type Props = {
  fragment: TableOfContentsPageNumberUpdatePanelFragment;
};

export function TableOfContentsPageNumberUpdatePanel({ fragment }: Props) {
  const { t } = useTranslation();
  const [deleteAttribute] =
    useDeleteTableOfContentsPageNumberFromPanelMutation();

  const onSave = async () => {};

  const onDelete = async () => {
    await deleteAttribute({
      variables: { attributeId: fragment.id },
      update(cache) {
        const id = cache.identify(fragment);
        cache.evict({ id });
        cache.gc();
      },
    });
  };

  return (
    <AttributePanel
      title={t("TableOfContentsPageNumberUpdatePanel.title")}
      onSubmit={onSave}
      onDelete={onDelete}
    />
  );
}
